<template>
    <ContainerContent
        class="mb-16 mt-4"
        max-class="max-w-sm-ceil"
        outer-container
    >
        <v-row>
            <v-col cols="12" md="6" offset-md="3">
                <h1 class="page-title">Order Status</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" offset-md="3">
                <OrderStatusPanel :order-status-params="orderStatusParams"></OrderStatusPanel>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import type { OrderStatus } from '~/types';
    import OrderStatusPanel from '~/components/orders/OrderStatusPanel/OrderStatusPanel.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';


    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;
    const route = useRoute();
    const params: Partial<OrderStatus> = route.query as Partial<OrderStatus>;
    const orderStatusParams = ref<Partial<OrderStatus>>(params);

    useHead({
        title: `Check Order Status | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Order Status'
            }
        ]
    });
</script>
